export default __webpack_public_path__ + "static/videovratnik-pro-89dd2e73b09fd0517a5dec66794918d6.png";